import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CompanyManager } from "../../../model/company-manager";
import { ClipboardService } from "../../../service/clipboard.service";

@Component({
  selector: 'ngx-generate-token-column',
  template: `
    <div *ngIf='(!isCreating && data?.token)' class="d-flex justify-content-between item-align-center manager-token"> 
      <input nbInput 
        class="w-100 p-0"
        [type]="isTokenVisible ? 'text' : 'password'"
        [value]="data.token"
        readonly>
      <button nbSuffix nbButton ghost size="tiny" (click)="toggleTokenVisibility()" class="ml-2">
        <nb-icon [icon]="isTokenVisible ? 'eye-off-outline' : 'eye-outline'"></nb-icon>
      </button>
      <button nbButton ghost size="tiny" (click)="copyToClipboard($event)">
        <nb-icon icon="clipboard-outline"></nb-icon>
      </button>
      <button nbButton ghost size='tiny' status='danger' (click)='delete()' nbTooltipStatus="danger" nbTooltip='토큰을 제거합니다.'>
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>

    <button *ngIf='(!isCreating && !data?.token)' nbButton size='tiny' status='primary' (click)='toggleCreation()'>
      생성
    </button>

    <div *ngIf='(isCreating && !data?.token)' class="d-flex justify-content-between item-align-center manager-token">
      <input nbInput
        class='p-0 w-100'
        placeholder="Form Picker"
        [(ngModel)]='data.expiration'
        [nbDatepicker]="formpicker">
      <nb-datepicker #formpicker></nb-datepicker>
      <button nbButton ghost size='tiny' status='success' (click)='create()' nbTooltip='토큰을 발급합니다.'>
        <nb-icon icon="checkmark-outline"></nb-icon>
      </button>
      <button nbButton ghost size='tiny' (click)='toggleCreation()' nbTooltip='토큰 발급을 취소합니다.'>
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  `,
  styles: [`
      .manager-token .ag-cell-wrapper {
        display: contents !important;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class GenerateTokenComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  public data: CompanyManager;
  public isTokenVisible: boolean = false;
  public isCreating: boolean = false;

  constructor(
    private clipboardService: ClipboardService,
  ) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
      this.params = params;
      this.data = this.params.data;
  }

  create() {
    this.params.context.create(this.data);
  }

  delete() {
    this.params.context.delete(this.data);
  }

  toggleCreation() {
    this.isCreating = !this.isCreating;
  }

  toggleTokenVisibility() {
    this.isTokenVisible = !this.isTokenVisible;
  }

  copyToClipboard(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.clipboardService.copy(this.params.value, true);
  }
}